import { FC } from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import image from 'src/assets/png/mock-room.png';
import { DiscountBanner } from 'src/components/discount-banner';
import { formatAcademicYear } from 'src/utils/format-academic-year';
import { formatFloorNumber } from 'src/utils/validators/format-floor';
import { theme } from 'src/styles/theme';

import { BookingDetailsContentShort } from '../your-details/booking-details/booking-details-short';

import { styles } from './styles';
import { RoomCardProps } from './types';

export const RoomCard: FC<RoomCardProps> = ({
    children,
    hasDiscount = false,
    withSmallImage = false,
    roomData,
    isAgreementsPage = false,
    building,
    termDuration,
    termStartDate,
    termEndDate,
    numberOfStudents,
}) => {
    const { t, i18n } = useTranslation();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const renderRoomDetails = () => {
        const unitType = roomData.unit_type.includes('Noms')
            ? roomData.unit_type.replace(' Noms', '')
            : roomData.unit_type;

        return (
            <Box css={styles.roomInfo}>
                <Typography variant="h4" css={styles.mainInfo}>
                    {roomData.room_code}
                </Typography>
                <Typography variant="h4" css={styles.mainInfo}>
                    {building?.building_name}
                </Typography>
                <Typography variant="h4" css={styles.mainInfo}>
                    {unitType}
                </Typography>
                <Typography variant="h4" css={styles.subInfo}>
                    <span
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: `${formatFloorNumber(roomData.floor, i18n.language, t)}`,
                        }}
                    />
                </Typography>
                <Typography variant="h4" css={styles.subInfo}>
                    {formatAcademicYear(roomData.academic_year)}
                </Typography>
            </Box>
        );
    };

    return (
        <Box>
            {hasDiscount && (
                <DiscountBanner id="room-card-discount-banner">
                    <Typography variant="body3">{t('discount_applied_info')}</Typography>
                </DiscountBanner>
            )}
            <Box css={styles.container}>
                <Box css={[styles.wrapper, isAgreementsPage && styles.adjustBorder]}>
                    <img
                        src={image}
                        alt="room"
                        css={withSmallImage ? styles.imageSmall : styles.image}
                    />
                    {renderRoomDetails()}
                </Box>
                {children}
                {isAgreementsPage && (
                    <Box css={isSmallScreen && styles.bookingDetailsWrapper}>
                        <BookingDetailsContentShort
                            roomData={roomData}
                            termDuration={termDuration}
                            termStartDate={termStartDate}
                            termEndDate={termEndDate}
                            numberOfStudents={numberOfStudents}
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};
